<div id="time-slot-daily-container">
  <span>{{ "COMPONENTS.TIME_SLOTS_DAILY.DESCRIPTION" | translate }}</span>
  @if (formgroup.get("timeSlotsDaily")?.touched && formgroup.get("timeSlotsDaily")?.hasError("minLength")) {
    <mat-error>{{ "COMPONENTS.TIME_SLOTS_DAILY.ERROR" | translate }}</mat-error>
  }
  <div class="items">
    @for (day of dates; track day; let index = $index) {
      <div class="item">
        <div class="title" [innerHTML]="days[index]"></div>
        <div class="body">
          @if (index === 5) {
            <mat-checkbox color="primary" [disabled]="formgroup.get('timeSlotsDaily')?.disabled" (change)="onCheckboxChange($event, { day: index, value: 1 })">
              {{ "COMPONENTS.TIME_SLOTS_DAILY.NONE" | translate }}
            </mat-checkbox>
          } @else {
            <mat-checkbox color="primary" [disabled]="formgroup.get('timeSlotsDaily')?.disabled" (change)="onCheckboxChange($event, { day: index, value: 1 })">
              {{ "COMPONENTS.TIME_SLOTS_DAILY.MORNING" | translate }}
            </mat-checkbox>
            <mat-checkbox color="primary" [disabled]="formgroup.get('timeSlotsDaily')?.disabled" (change)="onCheckboxChange($event, { day: index, value: 2 })">
              {{ "COMPONENTS.TIME_SLOTS_DAILY.AFTERNOON" | translate }}
            </mat-checkbox>
          }
        </div>
      </div>
    }
  </div>
</div>
